import React, { Component } from 'react';

import { format } from 'date-fns';
import brLocale from "date-fns/locale/pt-BR";

import Grid from '@material-ui/core/Grid';

import Text from '../../components/Inputs/Text/Text';
import SelectOption from '../../components/Inputs/Select/Select';
import { DatePicker } from '../../components/Inputs/DatePicker/DatePicker';

import EnumService from '../../services/Enum';

import {
    isBlank,
    isBlankHelperText,
    isCPFInvalid,
    isCPFHelperText,
    isNameCompoundHelperText,
    isNameCompoundInvalid,
    isNotBlank,
    isDateTimeInvalid,
    foraDaDataNascimentoPrevista,
    isDateTimeHelperText,
    isForaDaDataNascimentoPrevista,
} from '../../helper/ValidationHelper';
import {  } from '../../helper/MaskHelper';
import { cpfMask, nameMask } from '../../helper/MaskHelper';

export class DadosGerais extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            cpf: '',
            nome: '',
            nomeSocial: '',
            sexo: '',
            dataNascimento: '',
            raca: '',
            errors: {
                cpf: false,
                nome: false,
                nomeSocial: false,
                sexo: false,
                dataNascimento: false,
                raca: false,
            },
            helpers: {
                cpf: null,
                nome: null,
                nomeSocial: null,
                sexo: null,
                dataNascimento: null,
                raca: null,
            },
            disabled: {
                cpf: false,
            },
            optionsSexo: [],
            optionsRaca: [],
        }
        this.isValid = this.isValid.bind(this);
    }

    // INPUTS
    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.name === 'cpf' ? cpfMask(e.target.value) : e.target.name === 'nome' ? nameMask(e.target.value) : e.target.value,
            errors: { ...this.state.errors, [e.target.name]: false },
            helpers: { ...this.state.helpers, [e.target.name]: null }
        })
    }

    // INPUTS DATE TIME PICKER
    handleChangeDate = (e, name) => {
        this.setState({
            ...this.state,
            [name]: e,
            errors: { ...this.state.errors, [name]: false },
            helpers: { ...this.state.helpers, [name]: null }
        });
    }

    // VALIDAÇÕES
    isValid = () => {
        const cpfBlank = isBlank(this.state.cpf);
        const cpfInvalid = isCPFInvalid(this.state.cpf);
        const nomeBlank = isBlank(this.state.nome);
        const nomeCompoundInvalid = isNameCompoundInvalid(this.state.nome);
        const nomeSocialCompoundInvalid = isNotBlank(this.state.nomeSocial) && isNameCompoundInvalid(this.state.nomeSocial);
        const sexoBlank = isBlank(this.state.sexo);
        const racaBlank = isBlank(this.state.raca);
        const dataNascimentoBlank = isBlank(this.state.dataNascimento);
        const dataNascimentoInvalida = isDateTimeInvalid(this.state.dataNascimento)
        const dataNascimentoForaAnoPrevisto = foraDaDataNascimentoPrevista(this.state.dataNascimento);
        
        if (cpfBlank || cpfInvalid || nomeBlank || nomeCompoundInvalid || nomeSocialCompoundInvalid || sexoBlank || racaBlank || 
            dataNascimentoBlank || dataNascimentoInvalida || dataNascimentoForaAnoPrevisto
        ) {
            this.setState({
                errors: {
                    cpf: cpfBlank || cpfInvalid,
                    nome: nomeBlank || nomeCompoundInvalid,
                    nomeSocial: nomeSocialCompoundInvalid,
                    sexo: sexoBlank,
                    dataNascimento: dataNascimentoBlank || dataNascimentoInvalida || dataNascimentoForaAnoPrevisto ,
                    raca: racaBlank,
                },
                helpers: {
                    cpf: cpfBlank ? isBlankHelperText() : cpfInvalid ? isCPFHelperText() : null,
                    nome: nomeBlank ? isBlankHelperText() : nomeCompoundInvalid ? isNameCompoundHelperText() : null,
                    nomeSocial: nomeSocialCompoundInvalid ? isNameCompoundHelperText("Nome Social") : null,
                    sexo: sexoBlank ? isBlankHelperText() : null,
                    dataNascimento: dataNascimentoBlank ? isBlankHelperText : dataNascimentoInvalida ? isDateTimeHelperText() : dataNascimentoForaAnoPrevisto ? isForaDaDataNascimentoPrevista() : null ,
                    raca: racaBlank ? isBlankHelperText() : null,
                },
            });
            return false;
        }
        return true;
    }

    async componentDidMount() {
        const racas = await EnumService.listarRacas().then(res => res.data);
        const sexos = await EnumService.listarSexos().then(res => res.data);

        this.setState({
            ...this.state,
            optionsRaca: [...racas],
            optionsSexo: [...sexos],
        });
    }

    render() {
        return (
            <>
                <Grid container spacing={3} alignItems='center'>
                    <Grid item sm={12} lg={3}>
                        <Text
                            required
                            maxLength='14'
                            name="cpf"
                            label="CPF"
                            value={cpfMask(this.state.cpf)}
                            error={this.state.errors.cpf}
                            onChange={this.handleChange}
                            helperText={this.state.helpers.cpf}
                            disabled={this.state.disabled.cpf || this.props.disabled}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3} alignItems='center'>
                    <Grid item sm={12} lg={5}>
                        <Text
                            autoFocus
                            required
                            name="nome"
                            label="Nome Completo"
                            value={this.state.nome}
                            error={this.state.errors.nome}
                            onChange={this.handleChange}
                            helperText={this.state.helpers.nome}
                            disabled={this.props.disabled}
                        />
                    </Grid>
                    <Grid item sm={12} lg={5}>
                        <Text
                            name="nomeSocial"
                            label="Nome Social (Apenas para pessoas transgênero)"
                            value={this.state.nomeSocial}
                            error={this.state.errors.nomeSocial}
                            onChange={this.handleChange}
                            helperText={this.state.helpers.nomeSocial}
                            disabled={this.props.disabled}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3} alignItems='center'>
                    <Grid item sm={12} lg={2}>
                        <DatePicker
                            required
                            disableFuture
                            maxDate={format(new Date().setYear(new Date().getYear() - 18), 'MM/dd/yy', { locale: brLocale })}
                            minDate={format(new Date().setYear(1920), 'MM/dd/yyyy', { locale: brLocale })}
                            name='dataNascimento'
                            label="Data de Nascimento"
                            value={this.state.dataNascimento}
                            onChange={(e) => this.handleChangeDate(e, 'dataNascimento')}
                            error={this.state.errors.dataNascimento}
                            helperText={this.state.helpers.dataNascimento}
                            disabled={this.props.disabled}
                        />
                    </Grid>
                    <Grid item sm={12} lg={1}>
                        <SelectOption
                            required
                            label="Sexo"
                            name='sexo'
                            value={this.state.sexo}
                            onChange={(e) => this.handleChange(e)}
                            options={this.state.optionsSexo}
                            hiddenblank="true"
                            error={this.state.errors.sexo}
                            helperText={this.state.helpers.sexo}
                            disabled={this.props.disabled}
                        />
                    </Grid>
                    <Grid item sm={12} lg={2}>
                        <SelectOption
                            required
                            label="Raça"
                            name='raca'
                            value={this.state.raca}
                            onChange={(e) => this.handleChange(e)}
                            options={this.state.optionsRaca}
                            hiddenblank="true"
                            error={this.state.errors.raca}
                            helperText={this.state.helpers.raca}
                            disabled={this.props.disabled}
                        />
                    </Grid>
                </Grid>
            </>
        )
    }
}

export default DadosGerais;